import constants from '../constants';
import { SliderConfig, SlideData, SliderElementDataAttribute, SlidersConfig } from './getData';
import { getYoutubeVideoCover, getMediaUrl } from '../../../utils/helpers';
import { Api } from '../../../../../typings/api';

const getSliderPreview = ({ isExternalLink, relUrl, iconName, externalRelUrl, type }: SlideData): HTMLImageElement => {
	const sliderPreview = document.createElement('img');
	sliderPreview.className = `${constants.sliderPreviewClassName}`;
	sliderPreview.src = isExternalLink
		? getYoutubeVideoCover(externalRelUrl)
		: getMediaUrl(relUrl, type === Api.AssetItemFileTypes.MOVIE && iconName || '');

	return sliderPreview;
};

export default (
	htmlDocument: Document,
	items: SliderConfig[],
	pageSlidersData?: SlidersConfig,
): void => {
	items.forEach(({
		isEditedFromBackoffice,
		id,
		idInConfigs,
		isVisible,
		deps,
	}) => {
		if (!isEditedFromBackoffice) {
			return;
		}

		const element = htmlDocument.querySelector(`#${id}`) as HTMLElement;
		const sliderData = pageSlidersData && pageSlidersData[idInConfigs];

		if (sliderData) {
			const firstSlideData = 'slides' in sliderData ? sliderData.slides[0] : sliderData[0];

			if (firstSlideData) {
				const sliderPreview = getSliderPreview(firstSlideData);
				element.innerHTML = '';
				element.appendChild(sliderPreview);
			} else {
				element.innerHTML = '';
			}
		} else {
			element.innerHTML = '';
		}

		if (deps.length > 0) {
			element.setAttribute(SliderElementDataAttribute.deps, deps.join(';'));
		} else {
			element.removeAttribute(SliderElementDataAttribute.deps);
		}

		if (isVisible) {
			element.removeAttribute(SliderElementDataAttribute.hidden);
		} else {
			element.setAttribute(SliderElementDataAttribute.hidden, 'true');
		}
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/editableSliders/saveData.ts